<template>
  <div class="mfa-required">
    <Warning
      v-if="currentMfaState.key === MFA_STATES.SETUP.key && !skipMfa"
      class="mfa-warning"
      heading="MFA_REQUIRED.HEADING"
      subheading="MFA_REQUIRED.TEXT"
      :faq-link="faqLink"
      primary-action-text="MFA_REQUIRED.CTA"
      secondary-action-text="MFA_REQUIRED.SKIP"
      @on-primary-action="goToMfaSetup"
      @on-secondary-action="skip"
    />
    <div
      v-if="
        skipMfa ||
        props.showContentWithoutPass ||
        currentMfaState.key === MFA_STATES.ACTIVATED.key
      "
      class="content-wrapper"
    >
      <slot
        :mfa-requirement-passed="
          skipMfa || currentMfaState.key === MFA_STATES.ACTIVATED.key
        "
      />
      <div
        v-if="
          !skipMfa &&
          overlayContentWithoutPass &&
          currentMfaState.key !== MFA_STATES.ACTIVATED.key
        "
        class="mfa-required-content-overlay"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import MFA_STATES from '@/states/mfaStates';
import analytics from '@/tracking/analytics';
import smartFaqLinks from '@/smartFaq/smartFaqLinks';
import SmartFaqLink from '@/helpLink/SmartFaqLink.vue';
import {
  setLocalStorageItemWithExpiry,
  getLocalStorageItemWithExpiry,
} from '@/utils';
import Warning from 'src/app/components/warnings/Warning.vue';

const props = defineProps({
  showContentWithoutPass: Boolean,
  overlayContentWithoutPass: Boolean,
});

const store = useStore();
const currentMfaState = computed(() => store.state.user.mfaStatus);
const skipMfa = ref(!!getLocalStorageItemWithExpiry('skipMfa'));
const router = useRouter();
const faqLink = smartFaqLinks.MFA;

const goToMfaSetup = () => {
  router.push({
    name: 'partnerarea.account',
    params: { subpage: 'security' },
  });
  analytics.logEvent('mfa-required-setup');
};

const skip = () => {
  skipMfa.value = true;
  setLocalStorageItemWithExpiry('skipMfa', true, 7 * 24 * 60 * 60 * 1000); // remember mfa skip for one week
  analytics.logEvent('mfa-required-skip');
};

onMounted(() => store.dispatch('user/updateMfaStatus'));
</script>

<style lang="scss" scoped>
@import 'src/scss/styleguide/colors';
@import 'src/scss/constants';
@import 'src/scss/styleguide/type';

.content-wrapper {
  position: relative;
}

.mfa-required-content-overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: #fff;
  opacity: 0.8;
}

.mfa-warning {
  margin-bottom: 24px;
}
</style>
